import { render, staticRenderFns } from "./CommonForm.vue?vue&type=template&id=1f35689a&scoped=true"
import script from "./CommonForm.vue?vue&type=script&lang=js"
export * from "./CommonForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f35689a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-pharmacy\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f35689a')) {
      api.createRecord('1f35689a', component.options)
    } else {
      api.reload('1f35689a', component.options)
    }
    module.hot.accept("./CommonForm.vue?vue&type=template&id=1f35689a&scoped=true", function () {
      api.rerender('1f35689a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TkCommonPage/components/CommonForm.vue"
export default component.exports